var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    {
      staticClass: "application-footer",
      attrs: { app: "", dark: "", inset: "", color: "primary" }
    },
    [
      _c(
        "v-card",
        {
          staticClass: "flex primary",
          attrs: { flat: "", tile: "", dark: "" }
        },
        [
          _c(
            "v-card-text",
            { staticClass: "py-1 white--text overline text-center" },
            [
              _vm._v(
                "\n            Capital Legacy Solutions (Pty) Ltd is an Authorised Financial Services Provider.\n            The Legacy Protection Plan™ is underwritten by Guardrisk Life Ltd.\n        "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }